module.exports = __webpack_public_path__ + "img/google-meet.6dea696e.svg";